export default {
  name: 'EcsInteractionQueueWaitTimeMixin',

  methods: {
    formatWaitTime(time = '00:00:00') {
      const aux = time.split('.');
      return aux[0];
    },

    showQueueWaitTime(interaction) {
      return (
        !interaction.isInternal &&
        !interaction.isOutgoingEmail &&
        !interaction.isConsultReceiver &&
        !interaction.isDirectCall
      );
    }
  }
};
